import React, { useEffect, useState } from "react";
import { DUMMY_GET_ASPECT } from "../../dummy/aspect_dummy";
import { GetAspectGuide } from "../../actions/guideActions";
import { useDispatch, useSelector } from "react-redux";
import useDataSession from "../../customeHooks/useDataSession";

export default function ListAspect() {
  const [list, setList] = useState([]);
  const dispatch = useDispatch();
  const storeGet = useSelector((state) => state.smvm_get_aspect_guide);
  const { dataSession } = useDataSession();
  useEffect(() => {
    if (dataSession?.sessionInfo?.mehodId != undefined) {
      console.log("List aspect", dataSession?.sessionInfo?.mehodId);
      dispatch(GetAspectGuide(dataSession?.sessionInfo?.mehodId));
    }
  }, [dataSession?.sessionInfo?.mehodId]);
  useEffect(() => {
    if (storeGet.success) {
      console.log("List aspect", storeGet.data);
      setList(storeGet?.data?.data);
    }
  }, [storeGet]);

  // GetAspectGuide(dataSession.sessionInfo.mehodId)
  // smvm_get_aspect_guide
  return (
    <div>
      {list?.map((x, i) => {
        return (
          <>
            <div class="flex justify-between items-center  ">
              <p className="border-b w-full text-left text-sm font-bold text-gray-600">
                {x.categoryName}
              </p>
            </div>
            <div class="flow-root px-4" style={{}}>
              <ul role="list" class="divide-y divide-gray-200  ">
                {x?.aspectList?.map((y, z) => {
                  return (
                    <li class="py-2 sm:py-2 relative">
                      <div class="flex items-start space-x-4">
                        <div class="flex-shrink-0 text-sm font-medium">
                          {z + 1}
                        </div>
                        <div class="flex-1 min-w-0 text-left">
                          <p class="text-sm font-medium text-gray-900 truncate ">
                            {y.aspectName}
                          </p>
                          <p class="text-sm text-gray-500  ">{y.description}</p>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </>
        );
      })}
    </div>
  );
}
